<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/task/cron/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('renwumingcheng')">
            <yi_dictionary_select :max="999" type="CUSTOMER_TASK_NAME" :ids.sync="yt.conditions.name"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_system_task_cron_create')" size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)">
          {{ $t('xinzeng') }}
        </el-button>
      </template>

      <template #tuisongfangshi="scope">
        <div>
          {{ formatPushWays(scope.row) }}
        </div>
      </template>
      <template #shifouqiyong="scope">
        <div v-if="scope.row.enabled != null">
          <el-tag v-if="scope.row.enabled" type="success">{{ $t('shi') }}</el-tag>
          <el-tag v-else type="warning">{{ $t('fou') }}</el-tag>
        </div>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('tuisongrizhi', scope.row, '70%')">{{ $t('tuisongrizhi') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1', beforeShowEditDialogEdit)" v-if="utils.checkPower('web_system_task_cron_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/task/cron/delete')" v-if="utils.checkPower('web_system_task_cron_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('renwumingcheng')" required>
            <yi_dictionary_select :multiple="false" type="CUSTOMER_TASK_NAME" :ids.sync="yt.editObj.name"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('tuisongshijian')" required>
            <el-time-picker v-model="yt.editObj.pushTime" :picker-options="{}" format="HH:mm" :placeholder="$t('qingxuanze')" value-format="HH:mm"> </el-time-picker>
          </el-form-item>
          <el-form-item :label="$t('tuisongyonghu')" required>
            <yi_data_select type="customer_user" multiple :queryFilter="e => e.enabled == true" :ids.sync="yt.editObj.userIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('tuisongfangshi')" required>
            <yi_dictionary_select :multiple="true" :max="999" type="TASK_CRON_PUSH_WAY" :ids.sync="yt.editObj.pushWays"> </yi_dictionary_select>
          </el-form-item>
          <div v-show="yt.editObj.name === 'wellDefectComparisonSummaryTodayMorningTag' || yt.editObj.name === 'wellDefectComparisonSummaryYestNightTag'">
            <el-form-item :label="$t('yunxupiancha(%)')" required>
              <el-input v-model="yt.editObj.allowDeviation"></el-input>
            </el-form-item>
          </div>
          <div v-show="yt.editObj.name === 'wellSummaryOfMachinesWithoutWorkingTimeRecordsNightTag' || yt.editObj.name === 'wellSummaryOfMachinesWithoutWorkingTimeRecordsTag'">
            <el-form-item :label="$t('yunxingshijian(s)')" required>
              <el-input-number :min="0" v-model="extJsonObj.runTime" :precision="0"></el-input-number>
            </el-form-item>
          </div>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select size="mini" v-model="yt.editObj.enabled" :placeholder="$t('qingxuanze')" clearable>
              <el-option :key="1" :label="$t('shi')" :value="true"> </el-option>
              <el-option :key="0" :label="$t('fou')" :value="false"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/task/cron/create', beforCreate)" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('renwumingcheng')" required>
            <yi_dictionary_select :multiple="false" type="CUSTOMER_TASK_NAME" :ids.sync="yt.editObj.name"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('tuisongshijian')" required>
            <el-time-picker v-model="yt.editObj.pushTime" :picker-options="{}" format="HH:mm" :placeholder="$t('qingxuanze')" value-format="HH:mm"> </el-time-picker>
          </el-form-item>
          <el-form-item :label="$t('tuisongyonghu')" required>
            <yi_data_select type="customer_user" multiple :queryFilter="e => e.enabled == true" :ids.sync="yt.editObj.userIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('tuisongfangshi')" required>
            <yi_dictionary_select :multiple="true" :max="999" type="TASK_CRON_PUSH_WAY" :ids.sync="yt.editObj.pushWays"> </yi_dictionary_select>
          </el-form-item>
          <div v-show="yt.editObj.name === 'wellDefectComparisonSummaryTodayMorningTag' || yt.editObj.name === 'wellDefectComparisonSummaryYestNightTag'">
            <el-form-item :label="$t('yunxupiancha(%)')" required>
              <el-input v-model="yt.editObj.allowDeviation"></el-input>
            </el-form-item>
          </div>
          <div v-show="yt.editObj.name === 'wellSummaryOfMachinesWithoutWorkingTimeRecordsNightTag' || yt.editObj.name === 'wellSummaryOfMachinesWithoutWorkingTimeRecordsTag'">
            <el-form-item :label="$t('yunxingshijian(s)')" required>
              <el-input-number :min="0" v-model="extJsonObj.runTime" :precision="0"></el-input-number>
            </el-form-item>
          </div>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select size="mini" v-model="yt.editObj.enabled" :placeholder="$t('qingxuanze')" clearable>
              <el-option :key="1" :label="$t('shi')" :value="true"> </el-option>
              <el-option :key="0" :label="$t('fou')" :value="false"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/task/cron/update', beforUpdate)" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 推送日志 -->
      <template v-if="yt.editObj.action === 'tuisongrizhi'">
        <div class="dialog-scroller">
          <push_log :name="yt.editObj.name"></push_log>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import push_log from './log.vue';

export default {
  name: 'web_system_task_cron_list',
  components: {
    push_log
  },
  data() {
    return {
      printTemplateLoading: false,
      printTemplates: [],
      importShow: false,
      extJsonObj: {},
      columns: [
        {
          label: 'renwumingcheng',
          prop: 'name',
          type: 'dictionary',
          key: 'CUSTOMER_TASK_NAME',
          width: 250
        },
        {
          label: 'tuisongshijian',
          prop: 'pushTime'
        },
        {
          label: 'tuisongyonghu',
          prop: 'pushNickname'
        },
        {
          label: 'tuisongfangshi',
          prop: 'pushWays',
          type: 'slot'
        },
        {
          label: 'yunxupiancha(%)',
          prop: 'allowDeviation'
        },
        {
          label: 'shifouqiyong',
          prop: 'enabled',
          type: 'slot'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    beforCreate(params) {
      console.log(params, this.extJson);
      params.extJsonObj = this.extJsonObj;
      return params;
    },
    beforUpdate(params) {
      params.extJsonObj = this.extJsonObj;
      return params;
    },
    // 拼接推送方式字典值
    formatPushWays(row) {
      const pushWays = row.pushWays;
      if (pushWays && pushWays.length > 0) {
        const dictMap = this.store.state.dictJsonAll['TASK_CRON_PUSH_WAY'];
        if (dictMap) {
          let pushWaysStr = '';
          for (let i = 0; i < pushWays.length; i++) {
            const dictValue = dictMap[pushWays[i]];
            if (dictValue) {
              pushWaysStr += this.$t(dictValue) + ',';
            }
          }
          return pushWaysStr.substring(0, pushWaysStr.length - 1);
        }
      }
      return '';
    },
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      this.extJsonObj = {};
      row.enabled = true;
      return row;
    },

    // 编辑之前处理数据
    beforeShowEditDialogEdit(row) {
      this.extJsonObj = {};
      if (row.extJson) {
        this.extJsonObj = JSON.parse(row.extJson);
      }
      console.log(this.extJson);
      return row;
    }
  }
};
</script>
